import axios from "axios";

import {
  RENDER_PDF_REPORT_PREVIEW_URL,
} from "@/utils/constants/constants";

import {
  build_pdf_report_config_payload,
} from "./formal_document_template_helpers";

const PREVIEW_DEBOUNCE_MS = 280;

const build_preview_payload = (component) => ({
  project_id: Number(component.project_id || 0),
  entity_profile_id: component.target_entity_profile_id,
  application_id: component.target_application_id,
  config: build_pdf_report_config_payload(component.template_form),
});

export default {
  schedule_preview_refresh() {
    if (!this.template_form) {
      return;
    }
    this.clear_preview_refresh_timer();
    this.preview_refresh_timer = setTimeout(
      () => this.refresh_pdf_preview(),
      PREVIEW_DEBOUNCE_MS
    );
  },
  clear_preview_refresh_timer() {
    if (!this.preview_refresh_timer) {
      return;
    }
    clearTimeout(this.preview_refresh_timer);
    this.preview_refresh_timer = null;
  },
  refresh_pdf_preview() {
    this.preview_request_key += 1;
    const request_key = this.preview_request_key;
    this.preview_loading = true;
    axios
      .post(RENDER_PDF_REPORT_PREVIEW_URL, build_preview_payload(this), {
        headers: this.headers,
      })
      .then((response) => this.apply_pdf_preview_response(response, request_key))
      .catch((error) => this.apply_pdf_preview_error(error, request_key))
      .finally(() => this.finish_pdf_preview_request(request_key));
  },
  apply_pdf_preview_response(response, request_key) {
    if (request_key !== this.preview_request_key) {
      return;
    }
    this.preview_html = response.data?.data?.html || "";
    this.preview_error = "";
  },
  apply_pdf_preview_error(error, request_key) {
    if (request_key !== this.preview_request_key) {
      return;
    }
    this.preview_html = "";
    this.preview_error =
      error.response?.data?.message || "Failed to render the live PDF preview.";
  },
  finish_pdf_preview_request(request_key) {
    if (request_key !== this.preview_request_key) {
      return;
    }
    this.preview_loading = false;
  },
  get_generated_document_status_label() {
    return (
      this.generated_document?.status?.display_name ||
      this.generated_document?.status ||
      "Completed"
    );
  },
  open_generated_document() {
    if (!this.generated_document_url) {
      this.show_info("The generated PDF is not available to open yet.");
      return;
    }
    window.open(this.generated_document_url, "_blank", "noopener");
  },
  go_to_generated_reports() {
    this.$router.push("/generated_reports/");
  },
};
